/**
 * React Query hooks for invite codes
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { invitesApi } from '../api/invites'
import type { InviteCodeCreate } from '../types'

const INVITES_KEY = ['invites']

export function useInviteCodes(tenantId?: string) {
  return useQuery({
    queryKey: tenantId ? [...INVITES_KEY, tenantId] : INVITES_KEY,
    queryFn: () => invitesApi.list(tenantId),
  })
}

export function useCreateInviteCode() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: InviteCodeCreate) => invitesApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: INVITES_KEY })
    },
  })
}

export function useRevokeInviteCode() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (codeId: string) => invitesApi.revoke(codeId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: INVITES_KEY })
    },
  })
}
